import React from 'react';
import { Table, Spin, Empty } from 'antd';
import { ChartBox } from '../../../../ResultPanel/component/ChartBox';
import styles from '../../Layout/AnalyticsLayout.module.scss';
import ErrorDisplay from '../../ErrorDisplay';

interface ScatterTableChartProps {
  tableData: any[];
  column: any[];
  pointName: string;
  variableX: any;
  variableY: any;
  scatterTableLinks: string[];
  isLoading: boolean;
  error: string;
  isOfflineDataset: boolean;
}

export default function ScatterTableChart({
  tableData,
  column,
  isOfflineDataset,
  variableX,
  variableY,
  scatterTableLinks,
  isLoading,
  error,
}: ScatterTableChartProps) {
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          minHeight: '400px',
        }}
      >
        <Spin size='large' />
      </div>
    );
  }

  if (tableData.length === 0 && error.includes('Cmems error')) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Empty description={'Layer not available'} />
      </div>
    );
  }

  if (error || isOfflineDataset) {
    return <ErrorDisplay error={error} isOfflineDataset={isOfflineDataset} />;
  }

  return (
    <div id='Analytics-ScatterTable-Plot' className={styles.chartPointWrapper}>
      <ChartBox
        key='Scatter Table'
        title='Scatter Table'
        height='auto'
        plot={
          <Table
            columns={column}
            dataSource={tableData}
            scroll={{ x: 'fit-content', y: 330 }}
            pagination={false}
            size='small'
            style={{
              minHeight: '350px',
              background: 'white',
            }}
          />
        }
        dataset=''
        showAxis={true}
        xAxis={variableX ? variableX : undefined}
        yAxis={variableY ? variableY : undefined}
        link={scatterTableLinks}
      />
    </div>
  );
}
